/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot reloadable.
 */

import globalReducer from 'containers/App/reducer';
import loginReducer from 'containers/Login/reducer';
import modalReducer from 'containers/ModalController/reducer';
import notificationReducer from 'containers/Notifications/reducer';
import teamsReducer from 'containers/ProjectTeams/reducer';
import solutionsReducer from 'containers/Solutions/reducer';
import userManagementReducer from 'containers/UserManagement/reducer';
import whiteLabellingReducer from 'containers/WhiteLabelling/_utils/reducer';
import widgetsReducer from 'containers/Widgets/reducer';
import { combineReducers } from 'redux-immutable';

/**
 * Creates the main reducer with the asynchronously loaded ones
 */
export default function createReducer(asyncReducers) {
  return combineReducers({
    global: globalReducer,
    notification: notificationReducer,
    modal: modalReducer,
    widgets: widgetsReducer,
    solutions: solutionsReducer,
    teams: teamsReducer,
    userManagement: userManagementReducer,
    whiteLabelling: whiteLabellingReducer,
    login: loginReducer,
    ...asyncReducers,
  });
}
